module.exports.dateformatList = [
    'd-M-yyyy', 'd-M-yyyy', 'd.M.yyyy', 'd.M.yyyy',
    'd-MM-yy', 'd-M-yy', 'd-MM-yy', 'd-M-yy',
    'd.MM.yy', 'd.M.yy', 'd.MM.yy', 'd.M.yy',
    'd-M', 'd-M', 'd-MM', 'd-MM',
    'd.M', 'd.M', 'd.MM', 'd.MM', 'd', 'd',
    'MMMMMyy'
];